import documentsRepositoryService from "./DocumentsRepositoryService";

export const DocumentsService = {
  getDocumentsList: documentsRepositoryService.getDocumentList
};
